import { log, viewport, debounce } from "./_utils.js";

const sizeAffix = window.innerWidth < 767 ? "_s" : ""; // small video src on mobile
const path = window.location.pathname;
const wrapper_all = document.querySelectorAll(".video_wrapper, .video_wrapper_both");
const wrapper_storage = [];

const videos = document.querySelectorAll("video");
let videoPromises = [];
let videoNetworkStates = [];

let navList = document.querySelectorAll(".nav_references a");
let navActive = false;

let intersectingEntries = false;


/**
 * assign videos to wrapper_storage
 */
wrapper_all.forEach((wrapper,i) => {
  wrapper_storage[wrapper.dataset.id] = {
    "count": i,
    "videos": wrapper.querySelectorAll("video"),
    "intersecting": false,
  }
})

/**
 * set Video src
 * @param video
 */
videos.forEach(function (video) {
  const src = video.dataset.src;

  /** 
   * 
  https://davidwalsh.name/detect-supported-video-formats-javascript
  https://cconcolato.github.io/media-mime-support/#video/mp4;%20codecs=%22hev1.2.4.L120.B0%22
  if (video.canPlayType("video/mp4; codecs=hvc1")) { 
  */
  if (video.classList.contains('video_both')) {
    if (video.canPlayType('video/webm; codecs="av01.0.05M.08"')) {
      video.setAttribute('src', `/images/videos/${src}/${src}_AV1${sizeAffix}.webm`);
    }
    else if (video.canPlayType('video/webm; codecs="vp9"')) {
      video.setAttribute('src', `/images/videos/${src}/${src}_WebM${sizeAffix}.webm`);
    }
    else if (video.canPlayType('video/mp4')) {
      video.setAttribute('src', `/images/videos/${src}/${src}_H.264${sizeAffix}.mp4`);
    }
  }
  else {
    if (video.canPlayType('video/webm')) {
      video.setAttribute('src', `/images/videos/${src}${sizeAffix}.webm`);
    } else if (video.canPlayType('video/mp4')) {
      video.setAttribute('src', `/images/videos/${src}${sizeAffix}.mp4`);
    }
  }

});

/**
 * createObserver
 */
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 1,
};
const observer = new IntersectionObserver(observerCallback, observerOptions);
function observe_Wrapper_all() {  // called in init, if IntersectionObserver is supported
  wrapper_all.forEach((wrapper) =>
    observer.observe(wrapper)
  );
}



/**
 * observerCallback
 */
function observerCallback(wrapper) {
  if (wrapper) {
    intersectingEntries = wrapper;
  }

  wrapper.forEach((entry) => {
    // const videos = entry.target.querySelectorAll("video");
    const _thisWrapperID = entry.target.dataset.id;
    const _thisVisible = Boolean(entry.intersectionRatio === 1);
    wrapper_storage[_thisWrapperID].intersecting = _thisVisible; // store intersecting states
    handleNav(_thisWrapperID, _thisVisible);
  });

  // console.table(wrapper_storage);
  handleVideos();
}

/**
 * handleVideos
 */
function handleVideos() {
  Object.entries(wrapper_storage).forEach(entry => {
    const _id = entry[0];
    const _intersecting = entry[1].intersecting;
    const _videos = entry[1].videos;

    _videos.forEach(video => handleVideo(video, _intersecting));
    // console.log(_id, _intersecting, _videos);
    
  });

  set_videoNetwork_states()

}


/**
 * handleVideo
 * @param {Element} video 
 * @param {Boolean} state if video is intersection
 */
function handleVideo(video, _intersecting) {
  const videosLoading = Object.keys(videoNetworkStates).length;

  /* stop if network is full */
  if (_intersecting && video.readyState != 4 && videosLoading > 2) { // test network load
    console.log("pause: videos loading: ", Object.keys(videoNetworkStates).length);
    queuePlayback(true)
    return;
  };
  
  /* play & pause video */
  if (_intersecting) { 
    videoPromises[video.dataset.src] = video.play();
    console.log("play: ", video.dataset.src, _intersecting, videosLoading);
  } else { 
    if (videoPromises[video.dataset.src] !== undefined) {
      videoPromises[video.dataset.src].then(_ => {
        video.pause();
      })
        .catch(error => {
          error
        });
    }
  }
  
}



function handleVideo_old(video, state) {

  set_videoNetwork_states();
  const videosLoading = Object.keys(videoNetworkStates).length;

  // console.log("readyState ", video.dataset.src, video.readyState);

  // WIP: move queuePlayback here !!
  if (state && video.readyState != 4 && videosLoading > 2) { // test network load
    console.log("videos loading: ", Object.keys(videoNetworkStates).length);
    queuePlayback(true)
    return;
  };

  if (state) { // video play 
    videoPromises[video.dataset.src] = video.play();
    // console.log("play video: ", video.dataset.src);
  } else { // video pause
    if (videoPromises[video.dataset.src] !== undefined) {
      videoPromises[video.dataset.src].then(_ => {
        video.pause();
      })
        .catch(error => {
          error
        });
    }
  }
}



const timeouts = [];

function queuePlayback(param) {
  // console.log("queuePlayback() with", param);
  if (param === "resetTimer") return; // exit if no entries

  let intersectingIDs = intersectingEntries.map(entry => entry.target.dataset.id);
  const newTimeout = setTimeout(() => {
    console.log("queue setTimeout ", timeouts, intersectingIDs);
    while (timeouts.length) {
      clearTimeout(timeouts.pop());
    }
    observerCallback(intersectingEntries);
  }, 1000);

  timeouts.push(newTimeout);
}


/**
 * set_videoNetwork_states
 * networkState:
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/networkState
 * 
NETWORK_EMPTY	    0	There is no data yet. Also, readyState is HAVE_NOTHING.
NETWORK_IDLE	    1	HTMLMediaElement is active and has selected a resource, but is not using the network.
NETWORK_LOADING	  2	The browser is downloading HTMLMediaElement data.
NETWORK_NO_SOURCE	3	No HTMLMediaElement src found.
 */
function set_videoNetwork_states() {
  let _videoNetworkStates = [];

  videos.forEach(_ => {
    const state = _.networkState;
    if (state === 2) {
      _videoNetworkStates[_.dataset.src] = "downloading";
    }
  });
  videoNetworkStates = _videoNetworkStates;
  // console.log("videos loading: ", Object.keys(videoNetworkStates).length);
}




/**
 * handle Navigation
 */
function handleNav(isID, isState) {
  let isBigScreen = window.innerWidth > 992 ? true : false;
  const link = document.querySelector(`a[href="${path}#${isID}"]`);

  if (!isBigScreen) {
    return;
  }

  if (isState) {
    if (navActive != isID) {
      navList.forEach((_) => _.classList.remove("active"));
    }
    link.classList.add("active");
    navActive = isID;

    // history.replaceState(null, null, link.getAttribute('href'))
  }

  if (!isState && navActive != isID) {
    link.classList.remove("active");
  }

  // console.log( 'activeNav ' + navActive + ' ' + '  / isID ' + isID + ' ' + isState);
}

/**
 * init
 */
function init() {
  if (!!window.IntersectionObserver) {
    observe_Wrapper_all();
  } else {
    videos.forEach((video) => video.play());
  }
}

export default () => {
  return init();
};
